import { useDispatch } from 'react-redux';

import { usePhoneCallBtnLang } from './usePhoneCallBtnLang';
import dialogsManagerActions from 'redux/actions/dialogsManager.actions';

export function usePhoneCallBtn() {
  const dispatch = useDispatch();

  const lang = usePhoneCallBtnLang();

  const handleOnClick = () => {
    dialogsManagerActions.openCustomerPhoneProxySessionDialog()(dispatch);
  };

  return {
    lang,
    handleOnClick,
  };
}
